<template>
  <Modal
    title="Услуги и цены"
    :is-open="isOpen"
    :close="close"
    :withoutTemplate="true"

  >
    <With_Header_Modal_Template
      width="430px"
      without-footer
      title="Услуги и цены"
      :emit-close="true"
      @close="close"
    >
      <div class="modal_class">
        <div v-for="(item, specialization) in data" :key="specialization">
          <h3>{{ specialization}}</h3>
          <price-list :prices="item" :limit="false"/>
        </div>
      </div>
    </With_Header_Modal_Template>
  </Modal>
</template>

<script>
  import Modal from '../../../components/functional/Modal'
  import PriceList from "@/pages/Masters/MasterComponents/PriceList";
  import With_Header_Modal_Template from '@/components/Modals/ModalsTemplate/With_Header_Modal_Template'
  export default {
    name: 'MasterModal',
    components: {With_Header_Modal_Template, Modal, PriceList},
    props: {
      isOpen: Boolean,
      close: Function,
      data: [Array, Object]
    },
  }
</script>

<style scoped>
  h3 {
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 15px;
    line-height: 1.4;
    color: #383838;
  }
  .modal_class {
    overflow: auto;
    padding: 20px;
  }
</style>
